<span
  [rtTooltip]="time | amDateFormat: amDateFormatPattern"
  [rtTooltipPosition]="tooltipPosition"
  [attr.text-darkest]="colorDarkest ? '' : null"
>
  @if (prefix) {
    {{ prefix }}
  }
  @if (capitalize) {
    {{ time | rtTimeAgo: timeAgoOptions }}
  } @else {
    {{ time | rtTimeAgo: timeAgoOptions | lowercase }}
  }
</span>
